import store from "../../redux/store";
import { getErrorMessages } from "../../services/errors";
import type { ErrorResponse } from "../../services/types";
import { addNotification, clearNotification } from "./NotificationsSlice";
import { NotificationTypes, NotifyOptions } from "./types";

const dispatch = (
  type: NotificationTypes,
  message: string,
  options?: NotifyOptions,
) => {
  store.dispatch(
    addNotification({ type, message, duration: options?.duration }),
  );
};

/**
 * Centralized notification API. Works in both React and non-React code (e.g. the
 * axios interceptor) since it dispatches through the store singleton directly.
 * Components can use the `useNotify` hook for the same surface.
 */
export const notify = {
  success: (message: string, options?: NotifyOptions) =>
    dispatch(NotificationTypes.SUCCESS, message, options),
  error: (message: string, options?: NotifyOptions) =>
    dispatch(NotificationTypes.ERROR, message, options),
  warning: (message: string, options?: NotifyOptions) =>
    dispatch(NotificationTypes.WARNING, message, options),
  info: (message: string, options?: NotifyOptions) =>
    dispatch(NotificationTypes.INFO, message, options),
  /**
   * Surface every message extracted from an API error response as an error
   * notification. Replaces the per-page `getErrorMessages(err)` dispatch loops.
   */
  apiError: (err: ErrorResponse | string, options?: NotifyOptions) => {
    getErrorMessages(err).forEach((message) =>
      dispatch(NotificationTypes.ERROR, message, options),
    );
  },
  clear: () => store.dispatch(clearNotification()),
};
